import { render, staticRenderFns } from "./ccLivexbk.vue?vue&type=template&id=0258b92e&scoped=true"
import script from "./ccLivexbk.vue?vue&type=script&lang=js"
export * from "./ccLivexbk.vue?vue&type=script&lang=js"
import style0 from "./ccLivexbk.vue?vue&type=style&index=0&id=0258b92e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0258b92e",
  null
  
)

export default component.exports